
import React, { useState } from "react";
import { Box, Link, Rating, Stack, Tab, Button } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./../MProductPages.scss";
import MNavbar from "../../../../Components/Mobile/MNavbar/MNavbar";
import MRequestDemo from "../../../../Components/Mobile/MRequestDemo/MRequestDemo";
import CustomButton from "../../../../Components/CustomButton/CustomButton";
import MFooter from "../../../../Components/Mobile/MFooter/MFooter";

const MOnlineTransactionJourney = () => {
  const[openIndex,setOpenIndex] = useState(0);
  const handleMouseEnter = (index:any) =>{
    setOpenIndex(index);
  }
  const handleMouseLeave = () =>{
    setOpenIndex(0);
  }
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 992 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 991, min: 768 },
      items: 3,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 767, min: 200 },
      items: 1,
      slidesToSlide: 1,
    },
  };
  const whyChooseInsurventArray = [
    {
      image: "./images/wc_icon1.png",
      heading: "Comprehensive Integration",
      desc: "Insurvent excels in integrating a diverse array of third-party insurer services, creating a unified and user-centric insurance journey. From claims processing to policy management, we've got it all covered.",
    },
    {
      image: "./images/wc_icon2.png",
      heading: "User-Friendly Interface",
      desc: "Navigate the complexities of insurance effortlessly with our intuitive and user-friendly interface capabilities. Our online transaction journey is designed to be simple, efficient, and tailored to meet the demands of the modern consumer.",
    },
    {
      image: "./images/wc_icon3.png",
      heading: "Data Security",
      desc: "Trust is paramount, and at Insurvent, we prioritize the security of your information. Our robust security measures ensure that your data is protected throughout the online transaction journey.",
    },
    {
      image: "./images/wc_icon4.png",
      heading: "Innovation at Its Core",
      desc: " Stay ahead of the curve with our innovative approach. Insurvent is committed to driving industry advancements, keeping you at the forefront of digital insurance experiences.",
    },
  ];

  const product_basket = [
    {
      img: "./images/health_ins.svg",
      title: "Health Insurance",
      class: "health",
    },
    {
      img: "./images/car_ins.svg",
      title: "Car Insurance",
      class: "car",
    },
    {
      img: "./images/bike_ins.svg",
      title: "Bike Insurance",
      class: "bike",
    },
    {
      img: "./images/term_ins.svg",
      title: "Term Insurance",
      class: "term",
    },
    {
      img: "./images/investment_ins.svg",
      title: "Investment Plans",
      class: "investment",
    },
    {
      img: "./images/travel_ins.svg",
      title: "Travel Insurance",
      class: "travel",
    },
    {
      img: "./images/home_ins.svg",
      title: "Home Insurance",
      class: "home",
    },
    {
      img: "./images/shopkeeper_ins.svg",
      title: "Shopkeeper Insurance",
      class: "shopkeeper",
    },
    {
      img: "./images/commercial_ins.svg",
      title: "Commercial Vehicle",
      class: "commercial",
    },
  ];
  const onlineTransactionFeatureArray = [
    {
      image: "./images/instant_policy_issuance.png",
      heading: "Instant Policy Issuance",
      desc: "Seamlessly receive policies in an instant with our automated processes. Insurvent's technology ensures swift and efficient policy issuance, putting coverage in your customers hands within moments.",
    },
    {
      image: "./images/rt_premium_calculation.png",
      heading: "Real-Time Premium Calculation",
      desc: "Harness the power of real-time data analytics with our advanced algorithms. Our system processes dynamic data sets for precise and up-to-the-minute premium quotes, providing transparency and accuracy.",
    },
    {
      image: "./images/p&c_lifecycle_mgmt.png",
      heading: "Policy & Customer Lifecycle Management",
      desc: "Navigate the complete lifecycle effortlessly. Insurvent's integrates policy and customer data seamlessly, utilizing advanced data management tools for efficient tracking, analysis, and personalized experiences.",
    },
    {
      image: "./images/proposal_journey_mgmt.png",
      heading: "Proposal Journey Optimization",
      desc: "Experience a refined proposal journey with our tech-infused optimization. Our platform streamlines proposal submissions, making the process seamless and efficient for both insurers and customers.",
    },
    {
      image: "./images/ckyc_journry.png",
      heading: "CKYC (Centralized Know Your Customer) Journey",
      desc: "Streamline your policy buying processes with our CKYC journey. Insurvent integrates CKYC functionalities to ensure a thorough and efficient customer verification process, adhering to compliance standards seamlessly.",
    },
  ];

  return (
    <>
      <MNavbar />

      <Box className="productpage-wrapper">
        <Box
          className="prouct-header"
          padding={"0px 12px"}
          marginBottom={"40px"}
        >
          <Grid
            container
            rowSpacing={0}
            columnSpacing={3}
            paddingTop={"40px"}
            paddingBottom={"16px"}
          >
            <Grid xs={12} textAlign={"center"} marginBottom={"20px"}>
              <h2>
                <span>Welcome to Insurvent's Online Transaction Journey </span>–
                Your Passport to a Digitized Insurance Experience!
              </h2>
            </Grid>
            <Grid xs={12} textAlign={"center"}>
              <Box className="product_header_img">
                <img src="./images/ot_journey_header_img.svg" alt="ot_jouney" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          className="product_info_section"
          padding={"0px 12px"}
          marginBottom={"40px"}
        >
          <Grid container rowSpacing={0} columnSpacing={3}>
            <Grid xs={12} textAlign={"center"} marginBottom={"12px"}>
              <Box className="inner_box">
                <img
                  src="./images/ot_journey_desc_img.svg"
                  alt=""
                  style={{ maxHeight: "250px" }}
                />
                <h3 className="mb-2 mt-3">
                  Leading <span>OTJs</span>
                </h3>
                <p>
                  Insurvent leads the way in digital insurance integration,
                  leveraging advanced technology to create a seamless online
                  transaction journey. Our robust capabilities span across a
                  spectrum of third-party insurer services, delivering a
                  tech-focused solution for the digitized insurance buying
                  experience.
                </p>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          marginBottom={"40px"}
          padding={"0px 12px"}
          className="online_journey"
        >
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <h3 className="heading mb-6 text-center">
                What Sets
                <span> Insurvent's Online Transaction </span>Journeys Apart?
              </h3>
            </Grid>
            <Grid xs={12}>
              <Box>
                <Carousel
                  swipeable={true}
                  draggable={true}
                  showDots={true}
                  responsive={responsive}
                  infinite={true}
                  autoPlay={true}
                  removeArrowOnDeviceType={["tablet", "mobile"]}
                  autoPlaySpeed={3000}
                  arrows={false}
                  customTransition={"transform 800ms ease-in-out"}
                >
                  {onlineTransactionFeatureArray.map((item, index) => (
                    <Box className="iot_box">
                      <img src={item.image} alt="icon" />
                      <h6>{item.heading}</h6>
                      <p>{item.desc}</p>
                    </Box>
                  ))}
                </Carousel>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          marginBottom={"40px"}
          padding={"0px 12px"}
          className="seamless_buying_journeys"
        >
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12} textAlign={"center"}>
              <h3>
                Seamless
                <span> Buying Journeys</span>
              </h3>
            </Grid>
            <Grid xs={12}>
              <ul>
                {product_basket.map((data, index) => (
                  <li>
                    <Box className={`image_Section ${data.class}`}>
                      <img src={data.img} />
                    </Box>
                    <Box className="text_section">
                      <h6>{data.title}</h6>
                    </Box>
                    <Box className="ctaBtn" textAlign={"center"}>
                      <CustomButton
                        text_name={"Inquire"}
                        class_name="blueLgBtn"
                      />
                    </Box>
                  </li>
                ))}
              </ul>
            </Grid>
          </Grid>
        </Box>

        <Box
          marginBottom={"40px"}
          padding={"0px 12px"}
          className="why_choose_insurvent"
        >
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <h3 className="heading mb-6 text-center">
                Why
                <span> Choose Insurvent?</span>
              </h3>
            </Grid>
          </Grid>
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12} className="mb-8">
              <img
                src="./images/why_choose.png"
                alt="why_choose"
                style={{ margin: "auto", maxWidth: "250px" }}
              />
            </Grid>
            <Grid xs={12}>
              {whyChooseInsurventArray.map((item, index) => (
                <Box
                  className={`wc_box ${index === openIndex ? "open" : null}`}
                  onMouseEnter={() => handleMouseEnter(index)}
                  onMouseLeave={handleMouseLeave}
                >
                  <span>
                    <img src={item.image} alt="" />
                  </span>
                  <Box className="content_box">
                    <h6>{item.heading}</h6>
                    <p>{item.desc}</p>
                  </Box>
                </Box>
              ))}
            </Grid>
          </Grid>
        </Box>

        <Box marginBottom={"40px"} padding={"0px 12px"}>
          <Grid container columnSpacing={3} className="row">
            <Grid xs={12}>
              <Box
                sx={{
                  background: "#F3F2FC",
                  borderRadius: "12px",
                  padding: "12px",
                }}
              >
                <p style={{ textAlign: "center" }}>
                  Empower your digital insurance journey with Insurvent's
                  Tech-Driven Online Transaction Journey. From instant policy
                  issuance to real-time premium calculation and advanced
                  lifecycle management, we bring a tech-focused solution to
                  redefine your digital insurance experiences. Welcome to the
                  future of insurance integration – welcome to Insurvent.
                </p>
              </Box>
            </Grid>
          </Grid>
        </Box>

        <MRequestDemo heading={"Get"} />
      </Box>

      <MFooter />
    </>
  );
};

export default MOnlineTransactionJourney;
